import React from 'react'
import ReactDOM from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter as Router } from 'react-router-dom'
import { msalConfig, loginRequest } from './authConfig'
import { setupApiInterceptors } from './services/api'
import App from './App'
import './index.css'

const msalInstance = new PublicClientApplication(msalConfig)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
})

// Initialize MSAL (processes redirect response if returning from login)
// then wire up API interceptors before rendering
msalInstance.initialize().then(() => {
  // Set up API token interceptor — acquires token silently on every request.
  // MsalAuthenticationTemplate ensures the user is authenticated before any
  // API call is made, so acquireTokenSilent will always have an account.
  setupApiInterceptors(async () => {
    const accounts = msalInstance.getAllAccounts()
    if (accounts.length === 0) return ''

    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    })
    return response.accessToken
  })

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <Router basename="/acquisition/playbook">
            <App />
          </Router>
        </QueryClientProvider>
      </MsalProvider>
    </React.StrictMode>,
  )
})
